/**
 * Схема ответа GET `auth/token?permissionId=X`.
 *
 * Обмен general-токена на scoped-токен для конкретного permission'а.
 * После этого scoped-токен идёт во все остальные запросы, и доступ
 * ограничен этим permission'ом (роль, организация, театр, и т.д.).
 *
 * Request-shape — тривиальный `{ permissionId: number }`, держим
 * просто TS-интерфейсом без Zod-схемы (не нужна runtime-валидация).
 */

import {z} from 'zod';

export type GetScopedTokenRequest = {
  permissionId: number;
};

export const GetScopedTokenResponseSchema = z
  .object({
    token: z.string(),
    isInvitationsEnabled: z.boolean().optional(),
  })
  .passthrough();
export type GetScopedTokenResponse = z.infer<typeof GetScopedTokenResponseSchema>;
